import { getBaseUrl } from '../utils/getBaseUrl'; 

const baseURL = getBaseUrl() + 'pages/';
const baselookupURL = getBaseUrl() + 'lookup/';

export const GetAllPages = async (pageNumber = 1, pageSize = 50) => {
    try {
        const response = await fetch(`${baseURL}getall?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        const jsonData = await response.json();
        return jsonData;  // { pages: [...], totalCount: N }
    } catch (error) {
        console.error('Error fetching all records:', error);
    }
};


export const AddPage = async (pageBody) => {
    try {
        await fetch(baseURL + 'add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: pageBody
        });
        return "Page added";
    } catch (error) {
        console.error('Error adding page:', error);
    }
};

export const GetPageById = async (pagePk) => {
    try {
        const response = await fetch(baseURL + `byid?pk=${pagePk}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching page by pk:', error);
    }
};

export const GetAllMetaFor = async () => {
    try {
        const response = await fetch(baselookupURL + 'getall?name=metafor', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching all metafor:', error);
    }
};